/**
 * @fileoverview Main application component that sets up routing using TanStack Router
 */

// Library imports
import { RouterProvider, createRouter } from "@tanstack/react-router";

// Route configuration
import { PageLoading } from "./components/shared/loading";
import { routeTree } from "./routeTree.gen";

// Initialize router with route configuration
const router = createRouter({
  routeTree,
  // Mounted under /app on the production apex (taxos.net/app). Derived from Vite's base so dev
  // and prod stay aligned; strip the trailing slash that BASE_URL carries ("/app/" -> "/app").
  basepath: import.meta.env.BASE_URL.replace(/\/$/, "") || "/",
  // Enable default error boundaries for route error handling
  defaultErrorComponent: ({ error }) => (
    <div role="alert" className="error-boundary">
      <h1>Error</h1>
      <pre>{error.message}</pre>
    </div>
  ),
});

// Type registration for TanStack Router
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

/**
 * Root application component that provides routing functionality
 */
function App() {
  return (
    <RouterProvider
      router={router}
      // Provide fallback UI during route transitions
      defaultPendingComponent={() => <PageLoading />}
    />
  );
}

export default App;
